(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-arrivals"] && !Shopify.designMode) return;
  try {
    
  class LatestArrivals extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
    }

    #onClick = async (event) => {
      const link = event.target.closest('.pagination a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();

      const url = new URL(link.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('.latest-arrivals__results');
        if (!next) throw new Error('No results in response');
        this.querySelector('.latest-arrivals__results').replaceWith(next);
        this.#scrollToTop();
      } catch {
        window.location.href = link.href;
      } finally {
        this.removeAttribute('aria-busy');
      }
    };

    // Scroll back to the heading, clear of the sticky header. The header's
    // height is measured now because it reappears when scrolling up, and
    // scrollIntoView is used because Horizon scrolls .page-wrapper on desktop
    // but the window on mobile.
    #scrollToTop() {
      const heading = this.querySelector('.accent-heading');
      const header = document.querySelector('.header-section');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      heading.style.scrollMarginBlockStart = `${headerHeight + 16}px`;
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('latest-arrivals')) customElements.define('latest-arrivals', LatestArrivals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
